/*
------------------------------------------------
Delishop Framework
Hero Delishop
Version: 1.1
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initHero(section) {

        // Reservado para futuras funcionalidades.
        // En la versión MVP no es necesario ejecutar ninguna lógica.

    }

    document.addEventListener("DOMContentLoaded", function () {

        document.querySelectorAll(".dh-hero").forEach(initHero);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const hero = event.target.querySelector(".dh-hero");

        if (hero) {
            initHero(hero);
        }

    });

})();